import { PUBLIC_ADVISOR_STATUS } from '@/features/publicsite/registry/advisorStatus';
import type { Advisor } from '@/features/publicsite/types/registry/Advisor';
import type { PublicRegistryKey } from '@/i18n/dictionaries/publicRegistry';

/**
 * The quiet line on an adviser's card: "Atestat din 2026" for an attested one, "Validat din 2025"
 * for a validated one, from the date the profile entered that status. An attested adviser whose
 * date the server does not send keeps the plain "Atestat"; a validated one without it, nothing.
 */
export function advisorSince(
  advisor: Pick<Advisor, 'status' | 'validatedAt' | 'attestedAt'>,
): { key: PublicRegistryKey; year?: number } | null {
  const year = (iso: string | null | undefined) => {
    const parsed = iso ? new Date(iso).getFullYear() : NaN;
    return Number.isNaN(parsed) ? null : parsed;
  };
  if (advisor.status === PUBLIC_ADVISOR_STATUS.attested) {
    const attested = year(advisor.attestedAt);
    return attested
      ? { key: 'advisorsAttestedSince', year: attested }
      : { key: 'advisorsAttested' };
  }
  const validated = year(advisor.validatedAt);
  return validated ? { key: 'advisorsValidatedSince', year: validated } : null;
}
